import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/DashboardPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'DashboardRoute',
    component: () => import('../views/DashboardPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/employees',
    name: 'EmployeesRoute',
    component: () => import('../views/EmployeesPage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'instructor',
        name: 'InstructorTableRoute',
        component: () => import('../components/employee-table/InstructorsTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'frontdesk',
        name: 'FrontDeskTableRoute',
        component: () => import('../components/employee-table/FrontDeskTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'studiomanager',
        name: 'StudioManagerTableRoute',
        component: () => import('../components/employee-table/StudioManagerTable.vue'),
        meta: { requiresAuth: true },
      },
    ]
  },
  {
    path: '/sms-broadcast',
    name: 'SMSBroadcastRoute',
    component: () => import('../views/SMSBroadcastPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/sms-broadcast-log',
    name: 'SMSBroadcastLogRoute',
    component: () => import('../views/SMSBroadcastLogPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/class-types',
    name: 'ClassTypesRoute',
    component: () => import('../views/ClassTypesPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginRoute',
    component: () => import('../views/Auth.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/oauth/callback',
    name: 'OAuthCallbackRoute',
    component: () => import('../views/OAuthCallbackPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPasswordRoute',
    component: () => import('../views/Auth.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/account/users',
    name: 'AccountUsersRoute',
    component: () => import('../views/AccountUsersPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/workshop-credit',
    name: 'WorkshopCreditRoute',
    component: () => import('../views/WorkshopCreditPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/in-app-ad',
    name: 'InAppAdRoute',
    component: () => import('../views/InAppAdPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/fifth-tab-posts',
    name: 'FifthTabPostsRoute',
    component: () => import('../views/FifthTabPostsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/autolayout',
    name: 'AutolayoutRoute',
    component: () => import('../views/AutolayoutPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/url-generator',
    name: 'UrlGeneratorRoute',
    component: () => import('../views/UrlGeneratorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ryl-sync',
    name: 'RylSyncRoute',
    component: () => import('../views/RylSyncPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/analytics/landing',
    name: 'AnalyticsLandingRoute',
    component: () => import('../views/AnalyticsLandingPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/challenges/signups',
    name: 'ChallengeSignupRoute',
    component: () => import('../views/ChallengeSignupPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/teacher-class-confirm/:id',
    name: 'TeacherClassConfirmRoute',
    component: () => import('../views/layouts/TeacherClassConfirmPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/intro-offers',
    name: 'IntroOffersRoute',
    component: () => import('../views/layouts/IntroOffersPage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '5day',
        name: 'IntroOffers5DayRoute',
        component: () => import('../components/intro-offer-customer/FiveDayTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '15day',
        name: 'IntroOffers15DayRoute',
        component: () => import('../components/intro-offer-customer/FifteenDayTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '30day',
        name: 'IntroOffers30DayRoute',
        component: () => import('../components/intro-offer-customer/ThirtyDayTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '90day',
        name: 'IntroOffers90DayRoute',
        component: () => import('../components/intro-offer-customer/NinetyDayTable.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '365day',
        name: 'IntroOffers365DayRoute',
        component: () => import('../components/intro-offer-customer/OneYearTable.vue'),
        meta: { requiresAuth: true },
      }
    ]
  },
  {
    path: '/customer-journal',
    name: 'CustomerJournalRoute',
    component: () => import('../views/CustomerJournalPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dyp',
    name: 'DypMainRoute',
    component: () => import('../views/layouts/DypMainPage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'teams',
        name: 'TeamListRoute',
        component: () => import('../components/dyp/TeamList.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'team/create',
        name: 'TeamCreateRoute',
        component: () => import('../components/dyp/TeamCreate.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'team/edit/:id',
        name: 'TeamEditRoute',
        component: () => import('../components/dyp/TeamEdit.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'members',
        name: 'MemberListRoute',
        component: () => import('../components/dyp/MemberList.vue'),
        meta: { requiresAuth: true },
      },
    ]
  },
  {
    path: '/gift-card',
    name: 'GiftCardMainRoute',
    component: () => import('../views/GiftCardPage.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'config-list',
        name: 'GiftCardConfigListRoute',
        component: () => import('../components/gift-card/GiftCardConfigList.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'create-config',
        name: 'GiftCardCreateConfigRoute',
        component: () => import('../components/gift-card/GiftCardCreateConfig.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'edit-config/:configId',
        name: 'GiftCardEditConfigRoute',
        component: () => import('../components/gift-card/GiftCardEditConfig.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'universal-config-list',
        name: 'GiftCardUniversalConfigListRoute',
        component: () => import('../components/gift-card/GiftCardUniversalConfigList.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'universal-create-config',
        name: 'GiftCardUniversalCreateConfigRoute',
        component: () => import('../components/gift-card/GiftCardUniversalCreateConfig.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'universal-edit-config/:configId',
        name: 'GiftCardUniversalEditConfigRoute',
        component: () => import('../components/gift-card/GiftCardUniversalEditConfig.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/raferral/qr-codes-nametags',
    name: 'QrCodesNametagsRoute',
    component: () => import('../views/RaferralQRNametags.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/raferral/tracking',
    name: 'ReferralPageTrackRoute',
    component: () => import('../views/ReferralPageTrack.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/milestone-slideshows',
    name: 'MilestoneSlideshowsRoute',
    component: () => import('../views/MilestoneSlideshows.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/milestone-slideshows/:id',
    name: 'MilestoneSlideshowDetailRoute',
    component: () => import('../views/MilestoneSlideshowDetail.vue'),
    meta: { requiresAuth: true },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router